import { Avatar, Stack } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import { useAsset } from '@ocx-app/modules/configuration/use-asset.hook';
import { Button, Paper, Typography } from '@ocx/ui';

import { messages } from '../../profile-completed-popup.messages';
import { SizingMultiplier } from '../../../../../theme/constants';

type EIAVPromotionSectionProps = {
  onClick(): void;
};

export const EIAVPromotionSection: React.FC<EIAVPromotionSectionProps> = (props) => {
  const { onClick } = props;

  const ageRestrictedSrc = useAsset('AgeRestricted');

  return (
    <Stack component={Paper} outlined spacing={SizingMultiplier.md}>
      <Stack direction="row" alignItems="center" spacing={SizingMultiplier.md}>
        <Avatar src={ageRestrictedSrc} />
        <Typography variant="subtitle1">
          <FormattedMessage {...messages['profile-completed-action-sheet:eaiv-promotion-message']} />
        </Typography>
      </Stack>
      <Button onClick={onClick} fullWidth>
        <FormattedMessage {...messages['profile-completed-action-sheet:eaiv-promotion-button-text']} />
      </Button>
    </Stack>
  );
};
